/*
 * Copyright (C) 2024 CESNET z.s.p.o.
 *
 * oarepo-requests is free software; you can redistribute it and/or
 * modify it under the terms of the MIT License; see LICENSE file for more
 * details.
 */
export const REQUEST_TYPE = {
  CREATE: 'create',
  SUBMIT: 'submit',
  CANCEL: 'cancel',
  ACCEPT: 'accept',
  DECLINE: 'decline',
  SAVE: 'save',
}

export const REQUEST_MODAL_TYPE = {
  READ_ONLY: 'read-only',
  SUBMIT_FORM: 'submit-form',
}